export interface IValidationMetrics {
    impressions: number;
    cost: number | null;
    revenue: number;
    profit: number | null;
}

export interface IValidationDayResult {
    date: string;
    datapoint: string;
    datapointId?: string;
    adServer: string;
    status: 'pass' | 'fail' | 'error';
    stored?: IValidationMetrics;
    scraped?: IValidationMetrics;
    diff?: IValidationMetrics;
    error?: string;
}

export interface IValidationDay {
    date: string;
    status: 'pending' | 'pass' | 'fail' | 'skipped';
}

export interface IValidationPhase {
    adServer: string;
    status: 'pending' | 'running' | 'completed';
    currentDatapoint?: string;
    datapointsCompleted?: number;
    datapointsTotal?: number;
    days: IValidationDay[];
}

export interface IValidationStartResponse {
    jobId: string;
    status: string;
    totalDays: number;
    phases: IValidationPhase[];
}

export interface IValidationStatusResponse {
    jobId: string;
    status: 'running' | 'completed' | 'failed';
    totalDays: number;
    startDate: string;
    endDate: string;
    adServers: string[];
    forceValidation: boolean;
    phases: IValidationPhase[];
    dayResults?: IValidationDayResult[];
    completedAt?: string;
    error?: string;
    warning?: string;
}

export const ALL_AD_SERVERS = ['crossroads', 'pll', 'publica', 'xeworks'];
